import Link from "next/link";
import { useTranslation } from "react-i18next";

import { Feature, FeatureGuard } from "@sol/features";
import { Plus } from "@sol/icons";
import { Route } from "@sol/routing";
import { IClassroom } from "@sol/sdk";
import { Button } from "@sol/uikit/general/Button/Button";

import { SectionCard } from "@/shared/SectionCard";

import ClassroomCardContent from "../../../components/shared/ClassroomCardContent";

type Props = {
    id?: Feature;
    classroom?: IClassroom;
    showVisio?: boolean;
};

export const ClassroomCard = ({ classroom, showVisio, ...rest }: Props) => {
    const [t] = useTranslation();

    return (
        <SectionCard
            {...rest}
            title={t("component.classroomCard.title")}
            helper={
                <FeatureGuard feature={Feature.CLASSROOM_CREATE}>
                    <Link href={Route.CLASSROOMS_CREATE} passHref>
                        <Button type="primary" data-cy="add-classroom-link">
                            {t("page.home.createClassroom.link")} <Plus />
                        </Button>
                    </Link>
                </FeatureGuard>
            }
            data-cy="classroom-card"
        >
            <ClassroomCardContent classroom={classroom} showVisio={showVisio} />
        </SectionCard>
    );
};
